import { render, staticRenderFns } from "./CustomCardShipment.vue?vue&type=template&id=79313e31"
import script from "./CustomCardShipment.vue?vue&type=script&lang=js"
export * from "./CustomCardShipment.vue?vue&type=script&lang=js"
import style0 from "./CustomCardShipment.vue?vue&type=style&index=0&id=79313e31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports